<!-- Tapping the dimmed area closes it; the card stops the click so tapping it does not. -->
<div
  #root
  class="sent"
  [class.sent--reduced]="reduced"
  role="dialog"
  aria-modal="true"
  aria-labelledby="survey-sent-title"
  (click)="close()"
>
  <div class="sent__stage">
    <!-- the card the badge turns into (beat 3): starts as a circle the size of the badge -->
    <div #card class="card" (click)="$event.stopPropagation()">
      <button type="button" class="card__close rise rise--1" aria-label="Cerrar" (click)="close()">
        <mat-icon class="mdi mdi-close"></mat-icon>
      </button>

      <div class="card__body">
        <h2 id="survey-sent-title" class="card__title rise rise--1">Gracias por participar en esta encuesta</h2>
        <div class="card__message rise rise--2 flex flex-col items-center">
          <p *ngIf="name" class="font-bold">{{ name }} </p>
          <p class="font-normal text-lg">Tus respuestas se enviaron correctamente</p>
        </div>
        <button #action type="button" class="card__action rise rise--3" [disabled]="!ready" (click)="close()">
          Continuar
        </button>
      </div>
    </div>

    <!-- beat 1: the firework, over the card and under the badge -->
    <div class="fireworks" aria-hidden="true">
      <span class="fireworks__flash"></span>
      <span
        class="spark-fall"
        *ngFor="let spark of sparks; trackBy: trackSpark"
        [style.--ang]="spark.ang + 'deg'"
        [style.--dist]="spark.dist"
        [style.--len]="spark.len"
        [style.--col]="spark.color"
      >
        <span class="spark">
          <span class="spark__streak"></span>
          <span class="spark__dot" *ngIf="spark.dot"></span>
        </span>
      </span>
    </div>

    <!-- the badge: pops in (beat 1), sends the envelope away and lands the check (beat 2), then rises
         to the top of the card (beat 3). Three wrappers because each owns a different `transform`. -->
    <div class="hero" aria-hidden="true">
      <div class="hero__pop">
        <span class="ring ring--pop"></span>
        <span class="ring ring--a"></span>
        <span class="ring ring--b"></span>

        <span class="hero__disc"></span>
        <mat-icon class="hero__icon hero__mail mdi mdi-email-outline"></mat-icon>

        <span class="comet">
          <span class="comet__tail-wrap"><span class="comet__tail"></span></span>
          <span class="comet__head"></span>
        </span>

        <mat-icon class="hero__icon hero__check mdi mdi-check"></mat-icon>
      </div>
    </div>
  </div>
</div>
